import { render, staticRenderFns } from "./RbuSectionFluctuationEditor.vue?vue&type=template&id=0bd7448a"
import script from "./RbuSectionFluctuationEditor.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuationEditor.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionFluctuationEditor.vue?vue&type=style&index=0&id=0bd7448a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports